import { useTranslation } from "react-i18next";
import BlankModal from "components/commons/BlankModal";
import Loading from "components/commons/Loading";
import { useCreateContractModelMutation } from "../api/workContractApiSlice";
import ContractModelForm from "../views/ContractModelForm";

export default function NewContractModelModal() {

    const [t, i18n] = useTranslation("global");

    // API
    const [createCompany, {
        data: createResult,
        isLoading: createIsLoading,
        isSuccess: createSuccess,
        reset: createReset
    }] = useCreateContractModelMutation()

    const resetForm = () => {
        createReset();
    };

    // Contenuto del form con classi Bootstrap 5.3
    let content

    if (createIsLoading) {
        content = <Loading />
    } else if (createSuccess) {
        content = <div className="alert alert-success">
            Company created successfully!<br />
            <button className="btn btn-primary ml-3" onClick={resetForm}>Create another one</button>
        </div>
    } else content = <ContractModelForm onSubmit={createCompany} />


    return (
        <BlankModal
            title={t("absenceReport:menu.contract_new")}
            buttonLabel={
                <>
                    <i className="fa-solid fa-circle-plus"></i> {t("action.add")}
                </>
            }
            body={content}
        />
    );
}